<template>
    <div>
        <div class="settings-item" @click="modal = true">
            <div class="icon">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M20.91 11.12C20.91 16.01 17.36 20.59 12.51 21.93C12.18 22.02 11.82 22.02 11.49 21.93C6.63996 20.59 3.08997 16.01 3.08997 11.12V6.72997C3.08997 5.90997 3.70998 4.97998 4.47998 4.66998L10.05 2.39001C11.3 1.88001 12.71 1.88001 13.96 2.39001L19.53 4.66998C20.29 4.97998 20.92 5.90997 20.92 6.72997L20.91 11.12Z"
                        stroke="#292D32"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <div class="name">
                <span>უსაფრთხოება</span>
                <p>
                    პაროლის შეცვლა
                </p>
            </div>
            <div class="spacer"></div>
            <button>
                <svg
                    id="arrow-right"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                >
                    <path
                        id="Vector"
                        d="M0,13.2,5.433,7.767a1.655,1.655,0,0,0,0-2.333L0,0"
                        transform="translate(7.425 3.4)"
                        fill="none"
                        stroke="rgba(18,32,43,0.5)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                    />
                    <path
                        id="Vector-2"
                        data-name="Vector"
                        d="M0,0H20V20H0Z"
                        transform="translate(20 20) rotate(180)"
                        fill="none"
                        opacity="0"
                    />
                </svg>
            </button>
        </div>
        <transition name="fade">
            <div class="modals" v-if="modal">
                <div class="modals-inner">
                    <h2 class="modals-inner-title">
                        პაროლის შეცვლა
                    </h2>
                    <button class="modals-inner-closer" @click="modal = false">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12.121"
                            height="12.121"
                            viewBox="0 0 12.121 12.121"
                        >
                            <g
                                id="close-circle"
                                transform="translate(-244.109 -260.109)"
                            >
                                <path
                                    id="Vector"
                                    d="M0,10,10,0"
                                    transform="translate(245.17 261.17)"
                                    fill="none"
                                    stroke="#12202b"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                />
                                <path
                                    id="Vector-2"
                                    data-name="Vector"
                                    d="M10,10,0,0"
                                    transform="translate(245.17 261.17)"
                                    fill="none"
                                    stroke="#12202b"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                />
                            </g>
                        </svg>
                    </button>

                    <div class="models-user" v-if="userInfo">
                        <div class="avatar">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <g
                                    id="profile"
                                    transform="translate(-108 -252)"
                                >
                                    <path
                                        id="Vector"
                                        d="M4.6,8.87a1.818,1.818,0,0,0-.33,0,4.445,4.445,0,1,1,.33,0Z"
                                        transform="translate(115.56 254)"
                                        fill="none"
                                        stroke="#12202b"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    ></path>
                                    <path
                                        id="Vector-2"
                                        data-name="Vector"
                                        d="M1.815,1.373c-2.42,1.62-2.42,4.26,0,5.87a9.766,9.766,0,0,0,10.01,0c2.42-1.62,2.42-4.26,0-5.87A9.812,9.812,0,0,0,1.815,1.373Z"
                                        transform="translate(113.345 265.188)"
                                        fill="none"
                                        stroke="#12202b"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    ></path>
                                    <path
                                        id="Vector-3"
                                        data-name="Vector"
                                        d="M0,0H24V24H0Z"
                                        transform="translate(132 276) rotate(180)"
                                        fill="none"
                                        opacity="0"
                                    ></path>
                                </g>
                            </svg>
                        </div>
                        <div class="name">
                            <p>
                                {{ userInfo.first_name_ge }}
                                {{ userInfo.last_name_ge }}
                            </p>
                            <span>
                                {{ userInfo.first_name }}
                                {{ userInfo.last_name }}
                            </span>
                        </div>
                    </div>

                    <ValidationObserver
                        ref="observer"
                        v-slot="{ handleSubmit }"
                    >
                        <form
                            method="post"
                            @submit.prevent="handleSubmit(onSave)"
                            @keyup.enter="handleSubmit(onSave)"
                        >
                            <ValidationProvider
                                v-slot="{ errors }"
                                rules="required"
                                tag="div"
                            >
                                <div
                                    :class="{
                                        'calculator-inpout': true,
                                        'is-invalid': errors[0] ? true : false
                                    }"
                                >
                                    <input
                                        type="password"
                                        autocomplete="off"
                                        name="oldPassword"
                                        v-model="user.oldPasswrod"
                                        placeholder="ძველი პაროლი"
                                    />
                                </div>

                                <span
                                    v-if="errors[0]"
                                    class="invalid-feedback"
                                    role="alert"
                                >
                                    <strong>{{ errors[0] }}</strong>
                                </span>
                            </ValidationProvider>
                            <ValidationProvider
                                v-slot="{ errors }"
                                vid="password"
                                rules="required|min:8|Nospace"
                                tag="div"
                            >
                                <div
                                    :class="{
                                        'calculator-inpout': true,
                                        'is-invalid': errors[0] ? true : false
                                    }"
                                >
                                    <input
                                        type="password"
                                        autocomplete="off"
                                        name="password"
                                        v-model="user.newPasseword"
                                        placeholder="ახალი პაროლი"
                                    />
                                </div>
                                <span
                                    v-if="errors[0]"
                                    class="invalid-feedback"
                                    role="alert"
                                >
                                    <strong>{{ errors[0] }}</strong>
                                </span>
                            </ValidationProvider>
                            <ValidationProvider
                                v-slot="{ errors }"
                                rules="required|confirmed:password|min:8|Nospace"
                                tag="div"
                            >
                                <div
                                    :class="{
                                        'calculator-inpout': true,
                                        'is-invalid': errors[0] ? true : false
                                    }"
                                >
                                    <input
                                        type="password"
                                        autocomplete="off"
                                        name="password"
                                        v-model="user.newConfirmPassword"
                                        placeholder="გაიმეორეთ  პაროლი"
                                    />
                                </div>
                                <span
                                    v-if="errors[0]"
                                    class="invalid-feedback"
                                    role="alert"
                                >
                                    <strong>{{ errors[0] }}</strong>
                                </span>
                            </ValidationProvider>
                            <button class="calculator-button" type="submit">
                                შენახვა
                            </button>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {
    defineComponent,
    onBeforeMount,
    reactive,
    ref,
    watch
} from "@vue/composition-api";
import { useUser } from "../../hooks/user";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import axios from "axios";
import { Notyf } from "notyf";
export default defineComponent({
    components: {
        ValidationObserver,
        ValidationProvider
    },
    setup() {
        const modal = ref(false);
        const { getUser, userInfo } = useUser();
        const notyf = new Notyf({
            duration: 1000,
            position: {
                x: "right",
                y: "top"
            }
        });
        const observer = ref(null);
        const user = reactive({
            oldPasswrod: null,
            newPasseword: null,
            newConfirmPassword: null
        });
        const onSave = () => {
            axios({
                url: "/api/passwordReset",
                method: "POST",
                data: user
            }).then(e => {
                if (e.data.status) {
                    notyf.success(e.data.mass);
                    user.oldPasswrod = null;
                    user.newPasseword = null;
                    user.newConfirmPassword = null;
                    observer.value.reset();
                    modal.value = false;
                } else {
                    notyf.error(e.data.mass);
                }
            });
        };
        const BodyFix = status => {
            const body = document.body;

            if (status) {
                body.style.overflow = "hidden";
            } else {
                body.style.overflow = "scroll";
            }
        };

        watch(
            () => modal.value,
            (newVal, OldVal) => {
                BodyFix(newVal);
            }
        );
        onBeforeMount(async () => {
            if (!userInfo.value) {
                await getUser();
            }
        });
        return {
            onSave,
            userInfo,
            modal,
            user,
            observer
        };
    }
});
</script>
